import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { Container, Row, Col } from "react-bootstrap";
import { skills } from "../../content_option";

export const Skills = () => {
  const sectionRef = useRef(null);
  const [skillProgress, setSkillProgress] = useState(() => skills.map(() => 0));

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setSkillProgress(skills.map(() => 1));
      return undefined;
    }

    const section = sectionRef.current;
    if (!section || typeof IntersectionObserver === "undefined") {
      setSkillProgress(skills.map(() => 1));
      return undefined;
    }

    let frameId;
    let startedAt;
    let isRunning = false;
    const stagger = 1300;
    const duration = 900;
    const animate = (timestamp) => {
      if (startedAt === undefined) startedAt = timestamp;
      const elapsed = timestamp - startedAt;
      const nextProgress = skills.map((_, index) => {
        const amount = Math.min(Math.max((elapsed - index * stagger) / duration, 0), 1);
        return 1 - (1 - amount) ** 3;
      });
      setSkillProgress(nextProgress);
      if (elapsed < (skills.length - 1) * stagger + duration && isRunning) {
        frameId = window.requestAnimationFrame(animate);
      }
    };
    const start = () => {
      if (isRunning) return;
      isRunning = true;
      startedAt = undefined;
      setSkillProgress(skills.map(() => 0));
      frameId = window.requestAnimationFrame(animate);
    };
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        start();
      } else if (isRunning) {
        isRunning = false;
        window.cancelAnimationFrame(frameId);
        setSkillProgress(skills.map(() => 0));
      }
    }, { threshold: 0.1 });
    observer.observe(section);

    return () => {
      observer.disconnect();
      window.cancelAnimationFrame(frameId);
    };
  }, []);

  return (
    <section id="skills" className="About-header" ref={sectionRef}>
      <Container>
        <Row className="mb-5 mt-3 pt-md-3">
          <Col lg="8">
            <h1 className="display-4 mb-4">Skills</h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
        <Row className="sec_sp">
          <Col lg="5">
            <h3 className="color_sec py-4">Video Editing &amp; Post-Production</h3>
          </Col>
          <Col lg="7">
            {skills.map((data, i) => {
              const value = Math.round(data.value * skillProgress[i]);
              return (
              <div key={i}>
                <h3 className="progress-title" id={`skill-${i}`}>{data.name}</h3>
                <div
                  className="progress"
                  role="progressbar"
                  aria-labelledby={`skill-${i}`}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  aria-valuenow={value}
                  aria-valuetext={`${value}%`}
                >
                  <div className="progress-bar" aria-hidden="true" style={{ width: `${data.value * skillProgress[i]}%` }}>
                    <div className="progress-value">{value}%</div>
                  </div>
                </div>
              </div>
              );
            })}
          </Col>
        </Row>
      </Container>
    </section>
  );
};
